import React, { useState } from 'react';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import CloseIcon from '@material-ui/icons/Close';
import {
	makeStyles,
	Paper,
	Table,
	TableCell,
	TableHead,
	TableRow,
	Tooltip,
	Tab,
	Tabs,
	withStyles,
	Button,
	CircularProgress,
	TablePagination,
} from '@material-ui/core';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import { ErrorOutline } from '@material-ui/icons';

function ClientList({
	clientDetailList,
	jsxForExpandedClient,
	handleDocument,
	handleDelete,
	filteredClients,
	stableSort,
	getComparator,
	page,
	rowsPerPage,
	order,
	orderBy,
	setShowDocInfo,
	handleDocumentInformation,
	setClientJson,
	userType,
	setExtendInfo,
	setExtendModal,
}) {
	const useStyles = makeStyles({
		tableCell: {
			fontSize: '15px',
			borderBottom: '2px solid #c3c3c3',
		},
		// borderLeftCell: {
		// 	borderLeft: '10px solid var(--primary-color)',
		// },
		progressTab: {
			backgroundColor: '#F1F5F8',
			marginBottom: '1em',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			width: '34em',
		},
		expandContent: {
			transition: 'all .35s',
		},
		errorHandler: {
			textAlignLast: 'center',
			color: '#9c9c9c',
			padding: '3em 0',
		},
	});
	const styles = useStyles();

	function getCoolingPeriodEnd(client) {
		if (client?.apsStatus === 'Cooling period') {
			let coolingPeriodStart = dayjs.unix(client?.lastSignatureActivity);
			let extensionDay =
				client?.documentInformation?.document
					?.coolingPeriodExtensionDay;
			let durationDay = extensionDay ? extensionDay : 10;
			let coolingPeriodEnd = coolingPeriodStart.add(durationDay, 'day');
			let difference = coolingPeriodEnd.diff(dayjs(), 'day');
			if (difference < 0) {
				return coolingPeriodEnd.format('DD MMM YY');
			} else {
				return `${coolingPeriodEnd.format(
					'DD MMM YY'
				)} (${difference} days left)`;
			}
		} else {
			return '-';
		}
	}

	function openExtendModal(client) {
		setExtendModal(true);
		setExtendInfo({
			clientId: client?.keyValue,
			coolingPeriodExtensionDay:
				client?.documentInformation?.document
					?.coolingPeriodExtensionDay,
		});
	}

	return (
		<>
			{isEmpty(filteredClients) ? (
				<TableRow>
					<TableCell
						colSpan={3}
						align='center'
						className={styles.errorHandler}
					>
						There is currently no clients listed.
					</TableCell>
				</TableRow>
			) : (
				stableSort(filteredClients, getComparator(order, orderBy))
					.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
					.map((client) => {
						console.log('clientsclientclient', client);
						if (client?.documentInformation?.signatureRequests) {
							var sigReqObj =
								client?.documentInformation?.signatureRequests;

							var sigReqKeys =
								sigReqObj && Object.keys(sigReqObj);
							var timestamp =
								sigReqKeys[0] &&
								sigReqObj[sigReqKeys[0]].timestamp;
						}

						var isCoBrokerComplete = client?.isCoBrokerComplete;

						var clientLot =
							client?.documentInformation?.document?.lotActive
								?.lotSelected;

						return (
							<>
								<TableRow
									key={client.clientEmail}
									id={client.clientKey}
								>
									<TableCell
										className={styles.borderLeftCell}
									>
										<div className='clientLotNumber'>
											<span>
												{clientLot ? clientLot : '-'}
											</span>
										</div>
									</TableCell>
									<TableCell
										className={styles.borderLeftCell}
									>
										<div
											className='clientFullName'
											data-appcode={client.appCode}
											data-keyvalue={client.keyValue}
											data-salesagentpointer={
												client.salesAgentPointer
											}
											data-name={client.fullName}
											data-docsent={
												client?.documentInformation
													?.documentStatus
											}
											data-clientemail={
												client.clientEmail
											}
											onClick={(e) => {
												setShowDocInfo(true);
												handleDocumentInformation(
													client
												);
											}}
										>
											<span>{client.fullName}</span>
										</div>
									</TableCell>
									<TableCell>
										<div className='clientDate'>
											<span>
												{timestamp ? (
													dayjs(timestamp).format(
														'DD MMM, YYYY'
													)
												) : (
													<div> - </div>
												)}
											</span>
										</div>
									</TableCell>
									<TableCell>
										<p>{getCoolingPeriodEnd(client)}</p>
										<div>
											{getCoolingPeriodEnd(client) !==
												'-' &&
												userType === 'superadmin' && (
													<Button
														variant='contained'
														size='small'
														color='primary'
														onClick={() =>
															openExtendModal(
																client
															)
														}
														disableElevation
													>
														Extend
													</Button>
												)}
										</div>
									</TableCell>
									{jsxForExpandedClient(
										client.expandedClientInfo,
										client
									)}
									<TableCell>
										{(userType === 'salesadmin' ||
											userType === 'cobroker') &&
											client?.isForCurrentSalesAgent ===
												true && (
												<button
													className='btnDelete'
													onClick={(e) =>
														handleDelete(e, client)
													}
													data-appcode={
														client.appCode
													}
													data-name={client.fullName}
													data-clientemail={
														client.clientEmail
													}
												>
													<CloseIcon />
												</button>
											)}
										{userType === 'superadmin' && (
											<button
												className='btnDelete'
												onClick={(e) =>
													handleDelete(e, client)
												}
												data-appcode={client.appCode}
												data-name={client.fullName}
												data-clientemail={
													client.clientEmail
												}
											>
												<CloseIcon />
											</button>
										)}
										{userType === 'admin' && (
											<button
												className='btnDelete'
												onClick={(e) =>
													handleDelete(e, client)
												}
												data-appcode={client.appCode}
												data-name={client.fullName}
												data-clientemail={
													client.clientEmail
												}
											>
												<CloseIcon />
											</button>
										)}
									</TableCell>
									{/* TODO: COBROKER FEATURE */}
									{/* <TableCell>
										{(userType === 'superadmin' ||
											userType === 'admin') &&
											isCoBrokerComplete === true && (
												<Tooltip title='Document is ready to be signed'>
													<ErrorOutline />
												</Tooltip>
											)}
									</TableCell> */}
								</TableRow>
							</>
						);
					})
			)}
		</>
	);
}

export default ClientList;
